import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import MenuItem from '@material-ui/core/MenuItem';

import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import DeviationLanguage from '../../../../types/DeviationLanguage';
import { StyledDivider } from './styled';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    languagesMapped: DeviationLanguage[];
}

const categories = ['PA', 'KPI', 'PRP', 'PRPD', 'TRAINING', 'COMMUNICATION', 'GENERAL'];

const Form = (props: Props) => {
    const { baseInputProps, languagesMapped } = props;
    const { data } = baseInputProps;
    const { languages } = data;

    const { t } = useTranslation();

    const realLanguages = useMemo(() => {
        if (languages && languages.length > 0) {
            return languages;
        }

        return languagesMapped;
    }, [languagesMapped, languages]);

    return (
        <>
            <CustomInput {...baseInputProps} name='category' select>
                {categories.map(category => {
                    return (
                        <MenuItem key={category} value={category} >
                            {t('models.deviation.enum.category.' + category)}
                        </MenuItem>
                    );
                })}
            </CustomInput>

            <CustomInput {...baseInputProps} name='description' />

            <StyledDivider />

            {realLanguages.map((language: DeviationLanguage, index: number) => {
                return (
                    <CustomInput
                        {...baseInputProps}
                        name={'languages.' + index + '.translation'}
                        label={t('dialogs.deviation_details.translation_language', { language: language.description })}
                        key={language.code}
                    />
                );
            })}
        </>
    );
};

export default Form;
